import ServiceCRUD from '../../../../services/ServiceCRUDSCALE';

class ScalesService extends ServiceCRUD {
  constructor() {
    super('api/report/team');
  }
}

export default new ScalesService();
